import React from 'react';

const Stocks = () => {
    return (
        <div>
            <h1>Stocks</h1>
        </div>
    );
};

export default Stocks;
